import { main } from '../main';
import { VideoJSController } from "./videojs-controller";

/**
 * Demonstrates the use of the client-side IMA SDK in conjunction with the videojs player, which manages the
 * video player / ad player switching out of the box.
 */
main(VideoJSController);